export default __webpack_public_path__ + "static/media/PowerPoleMk2.256.8c60d0f7.png";